export const apiPath = {
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  changePassword: '/change-password',
  authemailverify: '/update-admin-email',
  logout: '/logout',
  dashboard: '/dashboard',
  // profile
  profile: '/profile',
  updateProfile: '/update-profile',
  verifyEmail: '/verify-email',

  getEnquiry: '/get-enquiry',
  // getStaticPages: '/get-static-pages',
  deleteUser: '/delete-user',
  getAllCategories: '/all-categories',

  // ------------------------------------------------------------------Decision Routes
  getDecisions: '/get-decisions',
  addDecision: '/add-decision',
  addToDecision: '/add-to-decision',
  listDecision: '/list-decision',
  detailDecision: '/detail-decision',
  deleteDecision: '/delete-decision',

  // ------------------------------------------------------------------Video Routes
  getVideo: '/get-video',
  addVideo: '/add-video',
  videoDetail: '/get-video-detail',
  deleteVideo: '/delete-video',
  updateVideo: '/update-video-detail',

  // ------------------------------------------------------------------Video Routes
  getReference: '/get-refrences',
  addReference: '/add-refrences',
  getCategory: '/get-category',

  // ------------------------------------------------------------------Antibiotic Routes

  addAntibiotic: '/add-category',
  getAntibiotic: '/get-antibiotics',

  // ------------------------------------------------------------------Category Routes

  addCategory: '/add-category',
  updateCategory: '/update-category',
  getCategpry: '/get-category',
  deleteCategory: '/delete-category',
  selectedCategory: '/selected-category',

  // ------------------------------------------------------------------Sub Category Routes

  getSubCategory: '/get-sub-category',
  addSubCategory: '/add-sub-category',
  deleteSubCategory: '/delete-sub-category',
  updateSubCategory: '/update-sub-category',
  getSubtoSub: '/get-sub-to-sub',
  addSubtoSub: '/add-sub-to-sub',
  updateSubtoSub: '/update-sub-to-sub',
  getTreeList: '/get-tree-list',

  // ------------------------------------------------------------------Chapter Routes
  addChapter: '/add-chapter',
  updateChapter: '/update-chapter',
  deleteChapter: '/delete-chapter',
  getChapters: '/get-chapters',
  updateChapterStatus: '/update-chapter-status',
  // ------------------------------------------------------------------Overview Routes
  getOverview: '/get-overview',
  addOverview: '/add-overview',
  getOverviewList: '/get-overview-list',

  // ------------------------------------------------------------------Static Routes
  getStaticPages: '/get-static-pages',
  addStaticPage: '/create-static-pages',
  updateStaticPage: '/update-static-pages',
  detailStaticPage: '/detail-static-pages',
  getPageListing: '/get-overview-detail-list',
  addOverviewList: '/add-to-overview-list'
};

export const API_URL = process.env.REACT_APP_API_URL
export const BACKEND = process.env.REACT_APP_BACKEND_URL


